import * as __au2ViewDef from './premium-funder.html';
import { customElement, INode, PLATFORM } from 'aurelia';
import { IApiService } from '../../../services/api';
import { IAppService } from '../../../services/app';
import { IRouter } from '@aurelia/router';

declare const initMPF;

@customElement({ ...__au2ViewDef, name: 'premium-funder' })
export class PremiumFunder {
    isProcessing = false;
    //MPFLive = 'https://edge.iqumulate.com/MVCProd/Scripts/MPF/MPF.js';
    MPFLive = 'https://www.macquariepacific.com/MVCProd/Scripts/MPF/MPF.js';
    MPFStage = 'https://prelive.iqumulate.com/MVC/Scripts/MPF/MPF.js';

    constructor(
        @IApiService readonly api: IApiService,
        @IAppService readonly appService: IAppService,
        @IRouter readonly router: IRouter,
        @INode readonly element: HTMLElement
    ) {
    }

    attached() {
        const isProduction =
            window.location.hostname === 'prod0-schemeapi.azurewebsites.net' ||
            window.location.hostname === 'apply.insuranceadviser.net';
        const scripttag = document.createElement('script');
        scripttag.setAttribute(
            'src',
            isProduction ? this.MPFLive : this.MPFStage
        );
        
        PLATFORM.document.head.appendChild(scripttag);
    }

    async processPayment() {
        const callBack = async (result) => {
            const parsedResult =
                typeof result === 'string' ? JSON.parse(result) : result;

            if (
                parsedResult.General.responseCode === '0' &&
                parsedResult.General.responseDescription === 'Success'
            ) {
                const policyVersionId =
                    this.appService.policyModel.policyVersionId;
                const schemeGuid = this.appService.scheme.schemeGuid;

                await this.api.postPremiumFunder(policyVersionId, {
                    QuoteOrPolicyVersionId: policyVersionId,
                    PolicyType: 'Policy',
                    PremiumFunderId: '100000002',
                    FundedAmount: parsedResult.General.amountFinanced,
                    LoanNumber: parsedResult.General.number,
                    QuoteNumber: '',
                });

                this.api.postDocPackGeneration({
                    Entities: [{entityId: policyVersionId, sequence: null}],
                    SchemeGuid: schemeGuid,
                });

                this.router.load('/complete');
            } else {
                this.isProcessing = false;
            }
        };

        if (!this.isProcessing) {
            this.isProcessing = true;
            const funderModel = await this.api.getPremiumFunderModel(
                this.appService.policyModel.policyVersionId
            );
            initMPF(
                callBack,
                funderModel.generalModel,
                funderModel.clientModel,
                funderModel.introducerModel,
                funderModel.policyModel
            );
        }
    }
}

    import { Metadata as $$M } from '@aurelia/metadata';
    import { ExpressionKind as $$EK } from '@aurelia/runtime';
    import { Controller as $$C, CustomElement as $$CE, IHydrationContext as $$IHC } from '@aurelia/runtime-html';

    // @ts-ignore
    const controllers = [];

    // @ts-ignore
    if (module.hot) {

    // @ts-ignore
    module.hot.accept();

    // @ts-ignore
    const hot = module.hot;

    let aurelia = hot.data?.aurelia;

    // @ts-ignore
    document.addEventListener('au-started', (event) => {aurelia= event.detail; });
    const currentClassType = PremiumFunder;

    // @ts-ignore
    const proto = PremiumFunder.prototype

    // @ts-ignore
    const ogCreated = proto ? proto.created : undefined;

    if (proto) {
      // @ts-ignore
      proto.created = function(controller) {
        // @ts-ignore
        ogCreated && ogCreated.call(this, controller);
        controllers.push(controller);
      }
    }

    // @ts-ignore
    hot.dispose(function (data) {
      // @ts-ignore
      data.controllers = controllers;
      data.aurelia = aurelia;
    });

    if (hot.data?.aurelia) {
      const newDefinition = $$CE.getDefinition(currentClassType);
      $$M.define(newDefinition.name, newDefinition, currentClassType);
      $$M.define(newDefinition.name, newDefinition, newDefinition);
      hot.data.aurelia.container.res[$$CE.keyFrom(newDefinition.name)] = newDefinition;

      const previousControllers = hot.data.controllers ?? [];
      if(previousControllers.length === 0) {
        // @ts-ignore
        hot.invalidate?.();
      }

      // @ts-ignore
      previousControllers.forEach(controller => {
        const values = { ...controller.viewModel };
        const hydrationContext = controller.container.get($$IHC)
        const hydrationInst = hydrationContext.instruction;

        const bindableNames = Object.keys(controller.definition.bindables);
        // @ts-ignore
        Object.keys(values).forEach(key => {
          if (bindableNames.includes(key)) {
            return;
          }
          // if there' some bindings that target the existing property
          // @ts-ignore
          const isTargettedByBinding = controller.bindings?.some(y =>
            y.ast?.$kind === $$EK.AccessScope
              && y.ast.name === key && y.targetProperty
          );
          if (!isTargettedByBinding) {
            delete values[key];
          }
        });
        const h = controller.host;
        delete controller._compiledDef;
        controller.viewModel = controller.container.invoke(currentClassType);
        controller.definition = newDefinition;
        Object.assign(controller.viewModel, values);
        if (controller._hydrateCustomElement) {
          controller._hydrateCustomElement(hydrationInst, hydrationContext);
        } else {
          controller.hE(hydrationInst, hydrationContext);
        }
        h.parentNode.replaceChild(controller.host, h);
        controller.hostController = null;
        controller.deactivate(controller, controller.parent ?? null, 0);
        controller.activate(controller, controller.parent ?? null, 0);
      });
    }
  }